// basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
// like '/berry-material-react/react/default'
export const BASE_PATH = '';

export const DASHBOARD_PATH = '/';
// where a fresh login lands: the homepage with a one-shot marker that triggers the
// motivational goal status (stripped by the homepage after render)
export const FROM_LOGIN_PARAM = 'fromLogin';
export const LOGIN_LANDING_PATH = `${DASHBOARD_PATH}?${FROM_LOGIN_PARAM}=1`;

const config = {
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 8,
    outlinedFilled: true,
    navType: 'light', // light, dark
    presetColor: 'default', // default, theme1, theme2, theme3, theme4, theme5, theme6
    locale: 'en', // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
    rtlLayout: false,
    container: false
};

export default config;

export const medhxFeaturesEnabled = process.env.REACT_APP_MEDHX_FEATURES_ENABLED === 'true';
